import React from "react";
import { motion } from "framer-motion";

const STATS = [
  { value: "500+", label: "Installations Delivered" },
  { value: "99.9%", label: "Uptime Maintained" },
  { value: "07+", label: "Years Of Experience" },
  { value: "120+", label: "Happy Clients" },
];

const Stats = () => {
  return (
    <section data-testid="stats-section" className="relative py-20 overflow-hidden bg-[#080F1B] border-y border-white/8">
      <div className="absolute inset-0 bg-grid-faint" />
      <div className="orb bg-[#FF6B00]/12 w-[500px] h-[500px] -bottom-40 right-0" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="flex flex-col gap-2"
            data-testid={`stat-${s.label.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
          >
            <div className="font-display text-5xl sm:text-6xl font-bold tracking-tighter leading-none">
              {s.value}
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#A0B2C6]">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
